<template>
	<div
		:class="
			$route.name == 'Leaderboard'
				? 'cand-dashboard-maincontainer-lead'
				: 'cand-dash-games'
		"
	>
		<header v-if="$route.name == 'Leaderboard'" class="cand-header">
			<img
				class="mr-4 pointer"
				@click="handleWebBack()"
				src="../../assets/img/homepage/back-arrow-blue.svg"
				alt=""
			/>
			<img class="mr-3" src="@/assets/leaderboard/leader-board.svg" alt="" />
			{{
				$route.query.type === "assessment"
					? "Assessment Leaderboards"
					: "Leaderboard"
			}}
		</header>
		<header class="mob-back-header">
			<img
				class="mr-3"
				@click="handleClick()"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			{{
				$route.query.type === "assessment"
					? "Assessment Leaderboards"
					: "Leaderboard"
			}}
		</header>
		<b-container
			class="px-0"
			:class="$route.name == 'SingleGame' ? 'max-100' : 'game-grid-container'"
		>
			<b-container
				class="game-dropdown leaderboard-left game-right"
				:class="$route.query.type == 'assessment' ? 'assessment' : ''"
			>
				<div
					:class="
						$route.name == 'Leaderboard'
							? ''
							: 'd-flex flex-column gap-3 pt-4 padding-left'
					"
				>
					<div class="games-lb-heading d-flex align-items-center game-grey-txt">
						<img
							class="mr-2"
							src="../../assets/newdesign/dashboard/games/leaderBoard.svg"
							alt=""
						/>

						{{
							$route.query.type === "assessment"
								? "Assessment Leaderboards"
								: "Leaderboard"
						}}
					</div>
					<div>
						<b-dropdown
							id="laptopdropdown"
							no-caret
							class="game-drop-parent w-100"
						>
							<template #button-content>
								{{ selectedGame.value ? selectedGame.text : "Select" }}
								<img
									src="../../assets/newdesign/dashboard/games/bluedown.svg"
									alt=""
								/>
							</template>
							<div class="game-dropdown-overflow">
								<b-dropdown-item
									v-for="(game, i) in $route.query.type === 'assessment' ||
									$route.name === 'AssessmentMarketplace'
										? assessmentTabs
										: games"
									:key="i"
									@click="selectGame(i)"
								>
									{{ capitalizeWords(game.text) }}
								</b-dropdown-item>
							</div>
						</b-dropdown>
					</div>

					<div id="mobiledropdown" class="my-2">
						<template v-if="isAssessment">
							<div
								v-for="(game, i) in assessmentTabs"
								:key="i"
								@click="selectGame(i)"
								:class="
									game.value == selectedGame.value ? 'game-sel' : 'game-unsel'
								"
							>
								{{ capitalizeWords(game.text) }}
							</div>
						</template>
						<template v-else>
							<div
								v-for="(game, i) in games"
								:key="i"
								@click="selectGame(i)"
								:class="
									game.value == selectedGame.value ? 'game-sel' : 'game-unsel'
								"
							>
								{{ capitalizeWords(game.text) }}
							</div>
						</template>
					</div>
				</div>
				<section
					class="d-flex align-items-center mt-2 px-2 mb-2"
					id="hideinlaptop"
					v-if="$route.name !== 'AssessmentMarketplace'"
				>
					<div class="leaderboard-tabs">
						<b-tabs v-model="activeTab" @input="onTabChange">
							<b-tab title="Candidates"></b-tab>
							<b-tab title="Colleges"></b-tab>
						</b-tabs>
					</div>
				</section>
				<div
					class="laptop-lb-tabs mt-2 align-items-center justify-content-between"
				>
					<div
						v-if="$route.query.type === 'assessment'"
						class="d-flex align-items-center"
					>
						<div
							class="ml-2 pointer"
							v-for="(game, i) in assessmentTabs"
							:key="i"
							@click="selectGame(i)"
							:class="
								game.value == selectedGame.value
									? 'lap-tabs-game-sel'
									: 'lap-tabs-game-unsel'
							"
						>
							{{ capitalizeWords(game.text) }}
						</div>
					</div>
					<section v-else class="d-flex align-items-center">
						<div
							class="ml-2 pointer"
							v-for="(game, i) in games"
							:key="i"
							@click="selectGame(i)"
							:class="
								game.value == selectedGame.value
									? 'lap-tabs-game-sel'
									: 'lap-tabs-game-unsel'
							"
						>
							{{ capitalizeWords(game.text) }}
						</div>
					</section>
					<!-- <div class="lb-total-user">
						Total Participants:&nbsp;{{ totalPlayers }}
					</div>  -->
					<section class="d-flex align-items-center">
						<div class="color-828282 fam-lato fw-R fs-15 mr-2">View by:</div>
						<div class="leaderboard-tabs">
							<b-tabs v-model="activeTab" @input="onTabChange">
								<b-tab title="Candidates" key="candidates"></b-tab>
								<b-tab title="Colleges" key="colleges"></b-tab>
							</b-tabs>
						</div>
					</section>
				</div>
				<div
					class="game-right-overflow"
					v-if="!loaderStat"
					:class="{
						'lead-empty-ht':
							leaderboardEntries.length == 0 && $route.name == 'Leaderboard',
					}"
				>
					<div
						v-if="leaderboardEntries.length > 0"
						ref="leaderboardContainer"
						class="game-lb-top-overflow"
						:class="{
							'game-lb-top-overflow-2': $route.name == 'MyProfile',
							'game-lb-top-overflow-3': hideProfile && !showPlay,
							'game-lb-top-overflow-4': hideProfile,
							'sticky-hidden': isStickyCardHidden,
							[activeTab === 0 ? 'candidates-view' : 'colleges-view']:
								!isAssessment,
							'assessment-view': isAssessment,
						}"
						@scroll="onScroll"
					>
						<div
							v-for="(player, i) in slicedEntries"
							:key="i"
							:ref="`playerEntry_${i}`"
				:class="{
					'my-rank-highlight':
						activeTab == 0 &&
						candidateInfo &&
						(player.id == candidateInfo._id ||
							player.fullName == candidateInfo.fullName),
				}"
						>
							<div
								class="d-flex align-items-center justify-content-between w-100 lead-card-padding"
							>
								<div class="d-flex align-items-center w-75">
									<div class="width54px text-center pr-3">
										<img
											v-if="player.position == 1"
											src="../../assets/newdesign/dashboard/games/first.svg"
											alt=""
										/>
										<img
											v-else-if="player.position == 2"
											src="../../assets/newdesign/dashboard/games/second.svg"
											alt=""
										/>
										<img
											v-else-if="player.position == 3"
											src="../../assets/newdesign/dashboard/games/third.svg"
											alt=""
										/>
										<span v-else class="game-grey-txt-4">{{
											player.position
										}}</span>
									</div>
									<div class="img-dimensions mr-3">
										<img
											:src="player.image"
											class="w-100 h-100"
											style="border-radius: 50%"
											alt=""
										/>
									</div>
									<div class="d-flex flex-column w80">
										<div
											class="game-black-txt text-truncate leader-name-width pr-3"
											:class="
												$route.name == 'Leaderboard' ? 'myp-blue-color' : ''
											"
										>
											{{ capitalizeWords(player.fullName) }}
										</div>
										<div
											class="game-grey-txt-2"
											v-if="$route.name != 'Leaderboard' && isAssessment"
										>
											<span>Assessment: {{ player.plays }} taken</span>
										</div>
									</div>
								</div>
								<div class="text-end">
									<div
										v-if="selectedGame.value == 'sudoku'"
										class="game-black-txt"
										v-html="formatTime(player.score)"
									></div>
									<div v-else class="game-black-txt">
										{{ player.score }}
										<span class="game-grey-txt-3">Pts</span>
									</div>
									<div
										class="game-grey-txt-2"
										v-if="$route.name == 'Leaderboard'"
									>
										<span v-if="isAssessment"
											>Assessment: {{ player.plays }} taken</span
										>
										<span v-else>Played: {{ player.plays }} times</span>
									</div>
								</div>
							</div>
							<div
								v-if="
									activeTab == 0 &&
									candidateInfo &&
									(player.id == candidateInfo._id ||
										player.fullName == candidateInfo.fullName)
								"
								ref="myRankRow"
								class="my-rank-reference-point"
							></div>
							<hr v-if="i != slicedEntries.length - 1" class="my-0 laptop-hr" />

							<hr v-if="i != slicedEntries.length - 1" class="mobile-hr my-2" />
						</div>
						<div v-if="loadingMore" class="d-flex justify-content-center py-2">
							<b-spinner label="Loading..."></b-spinner>
						</div>
					</div>
					<div
						v-else
						ref="leaderboardContainer"
						class="game-lb-top-overflow d-flex align-items-center justify-content-center"
						:class="{
							'game-lb-top-overflow-2': $route.name == 'MyProfile',
							'h-100': $route.name == 'Leaderboard',
							'game-lb-top-overflow-3':
								(hideProfile && !showPlay) ||
								($route.name == 'Leaderboard' && hideProfile),
						}"
					>
						<div v-if="$route.name == 'Leaderboard'" class="text-center p-3">
							<img src="../../assets/leaderboard/leaderboard-empty.svg" />
							<div class="lead-empty-txt text-center mt-4 mx-4">
								Looks like no one's ready for the top spot yet! Be the first to
								{{ isAssessment ? "achieve" : "play" }}!
							</div>
						</div>
						<div v-else class="text-center p-3">
							<img src="../../assets/leaderboard/lb-empty-mob.svg" />
							<div class="lead-empty-txt text-center mt-4 mx-5">
								Looks like no one's ready for the top spot yet! Be the first to
								{{ isAssessment ? "achieve" : "play" }}!
							</div>
						</div>
					</div>
					<transition name="slide-down">
						<div
							v-if="showGamePosition"
							class="game-own-update d-flex align-items-center justify-content-between w-100 px-4 py-2"
						>
							<div class="game-ur-position">Your Position</div>
							<div class="d-flex align-items-center w-75">
								<div class="width54px mob">
									<span class="game-blue-txt">{{ myRank.rank }}</span>
								</div>
								<div class="img-dimensions mr-3">
									<img
										:src="myRank.image"
										class="w-100 h-100"
										style="border-radius: 50%"
										alt=""
									/>
								</div>
								<div class="d-flex flex-column w80 mob">
									<div
										class="game-black-txt text-truncate"
										:class="
											$route.name == 'Leaderboard'
												? ''
												: 'leader-name-width pr-3'
										"
									>
										{{ capitalizeWords(myRank.fullName) }}
									</div>
									<span class="game-grey-txt-2">
										<span
											v-if="
												$route.query.type == 'assessment' ||
												$route.name == 'AssessmentMarketplace'
											"
											>Assessment: {{ myRank.plays }} taken</span
										>
										<span v-else>Played: {{ myRank.plays }} times</span>
									</span>
								</div>
							</div>
							<span
								v-if="selectedGame.value == 'sudoku'"
								class="game-black-txt"
								v-html="formatTime(myRank.current_score)"
							>
							</span>
							<span v-else class="game-black-txt"
								>{{ myRank.current_score }}
								<span class="game-grey-txt-3">Pts</span>
							</span>
						</div>
						<div
							v-if="showAssessmentPosition"
							class="game-own-update d-flex align-items-center justify-content-between w-100 px-4 py-2"
						>
							<div class="game-ur-position">Your Position</div>
							<div class="d-flex align-items-center w-75">
								<div class="width54px mob">
									<span class="game-blue-txt">{{ myRank.rank }}</span>
								</div>
								<div class="img-dimensions mr-3">
									<img
										:src="myRank.image"
										class="w-100 h-100"
										style="border-radius: 50%"
										alt=""
									/>
								</div>
								<div class="d-flex flex-column w80 mob">
									<div
										class="game-black-txt text-truncate"
										:class="
											$route.name == 'Leaderboard'
												? ''
												: 'leader-name-width pr-3'
										"
									>
										{{ capitalizeWords(myRank.fullName) }}
									</div>
									<span class="game-grey-txt-2">
										<span
											v-if="
												$route.query.type == 'assessment' ||
												$route.name == 'AssessmentMarketplace'
											"
											>Assessment: {{ myRank.plays }} taken</span
										>
										<span v-else>Played: {{ myRank.plays }} times</span>
									</span>
								</div>
							</div>
							<span
								v-if="selectedGame.value == 'sudoku'"
								class="game-black-txt"
								v-html="formatTime(myRank.current_score)"
							>
							</span>
							<span v-else class="game-black-txt"
								>{{ myRank.current_score }}
								<span class="game-grey-txt-3">Pts</span>
							</span>
						</div>
					</transition>

					<div
						v-if="showPlay && $route.name !== 'AssessmentMarketplace'"
						class="lb-no-played-card"
					>
						<main class="d-flex align-items-center">
							<section class="lb-img-box-shadow">
								<img
									class="h-100 w-100"
									v-if="selectedGame.text == 'Sudoku'"
									src="@/assets/leaderboard/lb-suduko.svg"
									alt=""
								/>
								<img
									class="h-100 w-100"
									v-if="selectedGame.text == 'Wordle'"
									src="@/assets/leaderboard/lb-wordle.svg"
									alt=""
								/>
								<img
									class="h-100 w-100"
									v-if="selectedGame.text == '2048'"
									src="@/assets/leaderboard/lb-2048.svg"
									alt=""
								/>
								<img
									class="h-100 w-100"
									v-if="selectedGame.text == 'Crossword'"
									src="@/assets/leaderboard/lb-crossword.svg"
									alt=""
								/>
							</section>
							<section id="mobile-gamecard" class="ml-3">
								<div class="mobile-gamecard-heading">
									<h3 class="mb-1 game-black-txt fs-12">
										{{ selectedGame.text }}
									</h3>
									<div class="mb-1 lp-top-right-subheads">
										<span class="js-grey-txt fs-12"
											>Analytical/Puzzle Game</span
										>
										<div class="fs-12">
											<img
												src="@/assets/leaderboard/lb-ppl.svg"
												class="mr-1"
												alt=""
											/>{{ leaderboardEntries.length }} Players
										</div>
									</div>
								</div>
							</section>
						</main>
						<section class="d-flex align-items-center">
							<b-button
								@click="gotoSingleGame()"
								class="w-100 lb-play-btn candash-addBtn mt-1"
								><img
									src="@/assets/leaderboard/game-btn-icon.svg"
									class="mr-1"
									alt=""
								/>
								Play Now</b-button
							>
						</section>
					</div>
				</div>
				<div class="leaderboard-skeleton" v-if="loaderStat">
					<div class="m-2" style="height: calc(100vh - 180px)">
						<div
							class="d-flex align-items-center w-100 lead-card-padding"
							style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
							v-for="j in 3"
							:key="j"
						>
							<div
								class="mr-4"
								style="height: 55px"
								:style="$route.name == 'Leaderboard' ? 'width:8%' : 'width:16%'"
							>
								<b-skeleton
									class="w-100 h-100"
									style="border-radius: 50%"
								></b-skeleton>
							</div>
							<div class="w-75 w-85">
								<b-skeleton class="w-75 h-25"></b-skeleton>
								<b-skeleton class="w-100 h-25"></b-skeleton>
							</div>
							<hr class="mobile-hr my-2" />
						</div>
					</div>
				</div>

				<div
					v-if="
						($route.name === 'Leaderboard' ||
							$route.query.type == 'assessment') &&
						total > 0
					"
					class="acs-paginaTion-new d-flex justify-content-between align-items-center mobile-hide-pagination"
				>
					<div class="d-flex">
						<span class="acs-gotopage-text mr-2 p-1">Go to page</span>
						<div class="acs-pagination-num">
							<b-form-input
								class="no-number"
								type="number"
								v-model="pageNumberToGo"
								@keydown="checkDigit"
								@keyup.enter="
									isValidPage(pageNumberToGo) && goToPage(pageNumberToGo)
								"
							>
							</b-form-input>
						</div>
						<div class="acs-pagination-addbtn">
							<b-button
								@click="goToPage(pageNumberToGo)"
								:disabled="!isValidPage(pageNumberToGo)"
							>
								<img
									src="../../assets/newdesign/assessPro/page-arrow.svg"
									alt=""
								/>
							</b-button>
						</div>
					</div>
					<div class="d-flex justify-content-center pagination ml-135">
						<b-pagination
							:total-rows="total"
							:per-page="pageCount"
							@change="onPageChange"
							v-model="currentPage"
							align="center"
							first-number
							last-number
							limit="4"
						>
							<template #prev-text
								><span
									><img
										src="../../assets/newdesign/assessPro/pageLeft.svg"
										alt=""
									/> </span
							></template>
							<template #next-text
								><span
									><img
										src="../../assets/newdesign/assessPro/pageRight.svg"
										alt="" /></span
							></template>
						</b-pagination>
					</div>
					<div class="d-flex align-items-center">
						<PaginationCountSelect
							:pagecount="pageCount"
							@update-value="updatePageCount"
						/>
						<div
							class="acs-gotopage-text mr-2 ml-4 d-flex align-items-center justify-content-end"
						>
							Results :
							<span class="ml-1">
								{{ pageStart }}
							</span>
							<span class="ml-1"> - {{ pageEnd }} </span>
							<span class="pl-1"></span> of <span class="pr-1"></span
							>{{ total }}
						</div>
					</div>
				</div>

				<span
					v-if="leaderboardEntries.length > 0"
					@click="checkAndRedirect()"
					class="cand-games-view-more d-flex align-items-center justify-content-center game-blue-txt-2 gap-2 p-4 pointer"
					>View more
					<img
						src="../../assets/newdesign/dashboard/games/blueRight.svg"
						alt=""
				/></span>
			</b-container>
			<b-container class="px-0 leaderboard-right-container">
				<AsmntTestcards
					v-if="$route.query.type == 'assessment'"
					:selectedCategory="selectedGame.value"
					:class="isLaptop ? 'mt-0' : 'mt-2 mx-2'"
				/>
				<template v-if="$route.query.type != 'assessment'">
					<b-card no-body class="overflow-hidden w-100 lb-top-card">
						<section class="d-flex align-items-center">
							<section class="img-box-shadow">
								<img
									v-if="selectedGame.text == 'Sudoku'"
									src="@/assets/leaderboard/lb-suduko.svg"
									alt=""
								/>
								<img
									v-if="selectedGame.text == 'Wordle'"
									src="@/assets/leaderboard/lb-wordle.svg"
									alt=""
								/>
								<img
									v-if="selectedGame.text == '2048'"
									src="@/assets/leaderboard/lb-2048.svg"
									alt=""
								/>
								<img
									v-if="selectedGame.text == 'Crossword'"
									src="@/assets/leaderboard/lb-crossword.svg"
									alt=""
								/>
							</section>
							<section id="mobile-gamecard" class="ml-3">
								<div class="mobile-gamecard-heading">
									<h3 class="mb-1">{{ selectedGame.text }}</h3>
									<div
										class="mb-1 lp-top-right-subheads d-flex align-items-center"
									>
										<span>Analytical/Puzzle Game</span>
										<span class="ml-3"
											><img
												src="@/assets/leaderboard/lb-ppl.svg"
												class="mr-1"
												alt=""
											/>{{ total }} Players</span
										>
									</div>
								</div>

								<b-button
									@click="gotoSingleGame()"
									class="w-100 lb-play-btn candash-addBtn mt-1"
									><img
										src="@/assets/leaderboard/game-btn-icon.svg"
										class="mr-1"
										alt=""
									/>
									Play Now</b-button
								>
							</section>
						</section>
					</b-card>

					<div
						class="game-right leaderboard-right mt-2 p-3 lb-right-subcontainer"
					>
						<section class="lb-right-card-height">
							<b-card
								no-body
								class="overflow-hidden w-100 lb-right-card position-relative p-3"
							>
								<img
									class="lb-right-cardimg position-absolute"
									src="@/assets/leaderboard/lb-right-card.svg"
									alt=""
								/>
								<h3>
									<img
										src="@/assets/leaderboard/lb-video.svg"
										class="mr-1"
										alt=""
									/>My Video Snapshot
								</h3>
								<p>
									Create your video introduction <br />
									using our innovative Video <br />
									Snapshot feature
								</p>
								<div
									class="lb-right-btn py-1 text-center pointer"
									@click="goToVideoSnap"
								>
									<img
										src="@/assets/leaderboard/lb-btn-video.svg"
										class="mr-1"
										alt=""
									/>{{
										candidateInfo.videoResume
											? "View my video snapshot"
											: "Create my video snapshot"
									}}
								</div>
							</b-card>
						</section>
						<footer class="">
							<div
								class="cd-right-snapshot-heading d-flex justify-content-center mt-2"
							>
								Follow Us
							</div>
							<div
								class="h-40px cd-helpsec-icon-card d-flex justify-content-center align-items-center mt-1"
							>
								<div>
									<a
										href="https://www.instagram.com/hire3x?igsh=MWQ0bzhqandjenprYg=="
										id="insta"
										target="_blank"
									>
										<img
											src="@/assets/icons/candidatedashboard/canddashright/Instagram.svg"
											alt=""
									/></a>
								</div>
								<div class="ml-3">
									<a
										href="https://www.facebook.com/profile.php?id=61552725574787&mibextid=AEUHqQ"
										id="fb"
										target="_blank"
									>
										<img
											src="@/assets/icons/candidatedashboard/canddashright/Facebook.svg"
											alt=""
									/></a>
								</div>
								<div class="ml-3">
									<a
										href="https://www.twitter.com/hire3x/"
										id="twitter"
										target="_blank"
									>
										<img
											src="@/assets/icons/candidatedashboard/canddashright/twitter.svg"
											alt=""
									/></a>
								</div>
								<div class="ml-3">
									<a
										href="https://www.linkedin.com/company/hire3x/"
										id="linkedin"
										target="_blank"
									>
										<img
											src="@/assets/icons/candidatedashboard/canddashright/Linkedin.svg"
											alt=""
										/>
									</a>
								</div>
							</div>
						</footer>
					</div>
				</template>
			</b-container>
		</b-container>
	</div>
</template>

<script>
import {
	getLeaderBoard,
	getMyRank,
	getLeaderBoards,
	getCollegeLeaderBoard,
	getAssessmentLeaderBoard,
	getParticularasmntPosition,
} from "../../utils/apiFunctions";
import { hasAccess } from "@/utils/tokenCheck";
import EventBus from "@/utils/EventBus";
import { mapGetters } from "vuex";
import AsmntTestcards from "./AsmntTestcards.vue";
import PaginationCountSelect from "@/components/PaginationCountSelect.vue";
import router from "@/router";
import { capitalizeWords } from "@/controllers/dashboard/helpers";

export default {
	props: {
		loadAgain: {
			type: Boolean,
			default: false,
		},
	},
	components: { AsmntTestcards, PaginationCountSelect },
	data() {
		return {
			loopvar: 7,
			loop4: 4,
			loaderStat: true,
			isAssessment: false,
			games: [
				{ text: "2048", value: "2048" },
				{ text: "Wordle", value: "wordle" },
				{ text: "Sudoku", value: "sudoku" },
				{ text: "Crossword", value: "crossword" },
			],

			assessmentTabs: [
				{ text: "Technical", value: "technical" },
				{ text: "Non-Technical", value: "nontechnical" },
				{ text: "Communication", value: "communication" },
			],
			gameType: this.$route.query.gameType
				? this.$route.query.gameType
				: this.$route.query.type === "assessment" ||
				  this.$route.name === "AssessmentMarketplace"
				? "technical"
				: "2048",

			leaderboardEntries: [],
			// slicedEntries: [],
			myRank: {},
			hideProfile: false,
			totalPlayers: null,
			activeGames: [],
			activeTab: 0,
			count: 10,
			currentPage: 1,
			pageNumberToGo: null,
			total: 0,
			pageStart: 0,
			pageEnd: 0,
			pageCount: 10,
			loadingMore: false,
			isLaptop: false,
			isMyRowVisible: false,
			observer: null,
			isAssessmentPosition: false,
		};
	},
	created() {
		const { type, mode } = this.$route.query;
		this.isAssessment =
			type === "assessment" || this.$route.name === "AssessmentMarketplace";
		const isCollege = mode === "college";

		// select game
		const sourceList = this.isAssessment ? this.assessmentTabs : this.games;
		this.selectedGame = sourceList.find((item) => item.value == this.gameType);

		if (!this.isAssessment) {
			this.leaderBoardCheck();
		}
		// set active tab
		this.activeTab = isCollege ? 1 : 0;

		// fetch leaderboard data
		if (this.isAssessment) {
			this.isAssessmentPosition = false;
			this.getAssessmentLeaderBoardData();
			this.getAssessmentPosition();
		} else if (isCollege) {
			this.getLeaderBoardCollege();
		} else {
			this.getLeaderBoard();
			// fetch rank (common)
			this.getMyRank();
		}
	},

	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
		this.setupIntersectionObserver();
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
		if (this.observer) {
			this.observer.disconnect();
		}
	},
	computed: {
		showAssessmentPosition() {
			return (
				this.isAssessment &&
				this.isAssessmentPosition &&
				!this.hideProfile &&
				!this.loaderStat &&
				this.activeTab == 0 &&
				!this.isMyRowVisible
			);
		},

		showGamePosition() {
			return (
				!this.isAssessment &&
				!this.hideProfile &&
				!this.loaderStat &&
				this.activeTab == 0 &&
				!this.isMyRowVisible
			);
		},
		normalizedEntries() {
			if (!this.leaderboardEntries) return [];

			// Candidate mode
			if (this.activeTab === 0) {
				return this.leaderboardEntries.map((e) => ({
					id: e.userID || e.id,
					fullName: e.fullName,
					image: e.image
						? e.image
						: "https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/profilePictureBlurred/profile17.png",
					plays: e.assessmentTakenCount || e.plays,
					score: e.score,
					position: e.position,
				}));
			}
			// College mode
			return this.leaderboardEntries.map((e) => ({
				id: e.collegeId,
				fullName: e.collegeName,
				image: e.image,
				plays: e.assessmentTakenCount || e.totalPlays,
				score: e.score,
				position: e.position,
			}));
		},

		slicedEntries() {
			// Leaderboard page → return all normalized entries (paged already)
			if (this.$route.name === "Leaderboard") {
				return this.normalizedEntries;
			}

			// MyProfile → show only 5
			if (this.$route.name === "MyProfile") {
				return this.normalizedEntries.slice(0, 5);
			}
			if (this.$route.name === "AssessmentMarketplace") {
				let entries = 5;
				if (this.showAssessmentPosition) {
					entries = 4;
				}
				return this.normalizedEntries.slice(0, entries);
			}

			// Other pages → show 10
			return this.normalizedEntries.slice(0, 10);
		},

		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
		showPlay() {
			if (this.hideProfile && !this.loaderStat) {
				if (
					(this.$route.query.gameType &&
						this.$route.query.gameType == this.selectedGame.value) ||
					this.$route.name == "Games"
				) {
					return false;
				} else return true;
			} else return false;
		},
		isStickyCardHidden() {
			return (
				!this.showAssessmentPosition &&
				!this.showGamePosition &&
				(this.hideProfile ||
					this.loaderStat ||
					this.activeTab != 0 ||
					this.isMyRowVisible)
			);
		},
	},
	watch: {
		loadAgain(newVal) {
			if (newVal) {
				this.getLeaderBoard();
				this.getMyRank();
			}
		},

		"$route.query": {
			handler(query) {
				if (this.loaderStat) return;
				this.isAssessment =
					query.type === "assessment" ||
					this.$route.name === "AssessmentMarketplace";
				// select assessment
				const sourceList = this.isAssessment ? this.assessmentTabs : this.games;

				this.selectedGame = sourceList.find(
					(item) => item.value == query.gameType
				);

				// fetch leaderboard
				if (this.isAssessment) {
					this.isAssessmentPosition = false;
					this.getAssessmentLeaderBoardData();
					this.getAssessmentPosition();
				} else {
					this.getLeaderBoard();
					// fetch rank
					this.getMyRank();
				}
			},
			deep: true,
		},
		leaderboardEntries: {
			handler() {
				this.$nextTick(() => {
					this.setupIntersectionObserver();
				});
			},
			deep: true,
		},
		myRank: {
			handler() {
				this.$nextTick(() => {
					this.setupIntersectionObserver();
				});
			},
			deep: true,
		},
		activeTab() {
			this.isMyRowVisible = false;
			this.setupIntersectionObserver();
		},
		pageStart() {
			this.$nextTick(() => {
				this.setupIntersectionObserver();
			});
		},
	},
	methods: {
		capitalizeWords(str) {
			return capitalizeWords(str);
		},
		async getAssessmentPosition() {
			try {
				const payload = {
					category: this.selectedGame.value,
					email: this.candidateInfo?.email,
				};

				const res = await getParticularasmntPosition(payload);

				if (res.status === 200) {
					const data = res.data.data;

					// switch based on tab
					const isCollege = this.activeTab === 1;

					const rank = isCollege ? data.college_rank : data.rank;
					const score = isCollege ? data.college_score : data.score;
					console.log(rank, score, "rank n score");
					//  if no data → hide
					if (rank == null || score == null) {
						this.hideProfile = true;
						this.isAssessmentPosition = false;
						return;
					}

					//  map properly
					this.myRank = {
						rank: rank,
						fullName: isCollege ? data.collegeName : data.full_name,
						current_score: score,
						image: isCollege ? data.college_image : data.profile_image,
						plays: data.assessmentTakenCount,
					};

					this.hideProfile = false;
					this.isAssessmentPosition = true;
				}
			} catch (error) {
				console.error("Error fetching position:", error);
				this.hideProfile = true;
				this.isAssessmentPosition = false;
			}
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		goToVideoSnap() {
			this.$router.push({
				name: "CandidateDashboard",
				params: {
					type: "videoSnap",
				},
			});
		},
		openLink() {
			window.open("https://youtu.be/vczpIL2FZpA?si=I9Vn1n1hD2GQ94qs", "_blank");
		},
		gotoSingleGame() {
			this.$router.push({
				name: "SingleGame",
				query: {
					gameType: this.selectedGame.value,
					redirect: this.$route.query.redirect,
					from: this.$route.query.from,
					leaderboard: true,
				},
			});
		},
		handleClick() {
			if (this.$route.query.from == "profile") {
				this.$router.replace({ path: "/myprofile" });
			} else if (this.$route.query.from == "home") {
				this.$router.replace({ path: "/Homepage" });
			} else if (this.$route.query.redirect) {
				this.$router.replace({
					path: "/games",
					query: { redirect: this.$route.query.redirect },
				});
			} else {
				this.$router.go(-1);
			}
		},
		handleWebBack() {
			console.log("uytrdfg", this.$route.query);

			if (this.$route.query.type === "assessment") {
				this.$router.push({
					name: "AssessmentMarketplace",
				});
			}
			if (this.$route.leaderboard) {
				this.$router.replace({
					path: "/leaderboard",
					query: { redirect: this.$route.query.redirect },
				});
			} else if (this.$route.query.redirect) {
				this.$router.replace({
					path: "/games",
				});
			} else if (this.$route.name === "AssessmentMarketplace") {
				return;
			} else {
				this.$router.go(-1);
			}
		},
		checkAndRedirect() {
			if (!hasAccess()) {
				console.log("modal open");

				EventBus.$emit("open-login-modal");
			} else {
				this.pushToLeaderBoard();
			}
		},

		pushToLeaderBoard() {
			const query = {
				gameType: this.selectedGame.value,
				redirect: true,
			};
			if (this.$route.name === "AssessmentMarketplace") {
				this.$router.push({
					name: "Leaderboard",
					query: {
						type: "assessment",
						gameType: this.selectedGame.value,
						mode: "candidate",
						from: "AssessmentMarketplace",
					},
				});
			} else {
				this.$router.push({
					name: "Leaderboard",
					query: query,
				});
			}
		},

		selectGame(i) {
			// select game
			this.selectedGame = this.isAssessment
				? this.assessmentTabs[i]
				: this.games[i];

			// reset pagination
			this.currentPage = 1;
			this.pageCount = 10;

			// fetch data
			if (this.isAssessment) {
				this.isAssessmentPosition = false;
				this.getAssessmentLeaderBoardData();
				this.getAssessmentPosition();
				return;
			}
			this.loaderStat = true;
			if (this.activeTab === 0) {
				this.getLeaderBoard();
				this.getMyRank();
			} else if (this.activeTab === 1) {
				this.getLeaderBoardCollege();
			}
		},
		async leaderBoardCheck() {
			try {
				const res = await getLeaderBoards();
				if (res.status == 200) {
					this.activeGames = res.data.data.active_leaderboards;
					if (this.$route.name == "MyProfile" || this.$route.name == "games") {
						if (!entries.includes(selectedGame.value)) {
							let foundGame = this.games.find(
								(game) => game.value === this.activeGames[0]
							);

							if (foundGame) {
								this.selectedGame = foundGame;
							}
						}
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		async getAssessmentLeaderBoardData(append = false) {
			console.log("assessment called");
			if (!append && this.leaderboardEntries.length === 0) {
				this.loaderStat = true;
			}
			let payload = {};
			if (this.$route.name === "Leaderboard") {
				payload = {
					page: this.currentPage - 1,
					count: this.pageCount,
				};
			}

			// Determine type based on activeTab
			const type = this.activeTab === 1 ? "college" : "candidate";
			const res = await getAssessmentLeaderBoard(this.selectedGame.value, {
				...payload,
				type: type,
			});

			if (res.status == 200) {
				this.loaderStat = false;
				const data = res.data.data;

				if (this.currentPage != 1 && !this.isLaptop) {
					this.leaderboardEntries = [
						...this.leaderboardEntries,
						...data.entries,
					];
				} else {
					this.isMyRowVisible = false;
					this.leaderboardEntries = data.entries;
				}
				if (!this.isAssessmentPosition) {
					if (data.myRank) {
						this.myRank = data.myRank;
						this.hideProfile = false;
					} else {
						this.hideProfile = true;
					}
				}
				// Update pagination-related fields ONLY for Leaderboard
				if (this.isAssessment) {
					this.total = data.total; // backend returns totalPlayers
					// Only update pageStart when replacing (not appending) so ranks stay correct
					if (!(this.currentPage != 1 && !this.isLaptop)) {
						this.pageStart = data.pageStart;
					}
					console.log("Page End from API:", data.pageEnd);
					console.log("Page start from API:", data.pageStart);
					this.pageEnd = data.pageEnd;
					this.pageCount = data.count;
				}

				this.loaderStat = false;
				this.loadingMore = false;
			}
		},
		async getLeaderBoard(append = false) {
			let payload = {};
			if (this.$route.name === "Leaderboard") {
				payload = {
					page: this.currentPage - 1,
					count: this.pageCount,
				};
			}
			const res = await getLeaderBoard(this.selectedGame.value, payload);
			if (res.status == 200) {
				const data = res.data.data;
				this.total = data.totalPlayers;
				this.pageEnd = data.pageEnd;

				if (this.currentPage != 1 && !this.isLaptop) {
					// Appending — keep original pageStart so rank numbers stay correct
					this.leaderboardEntries = [
						...this.leaderboardEntries,
						...data.entries,
					];
				} else {
					this.pageStart = data.pageStart;
					this.isMyRowVisible = false;
					this.leaderboardEntries = data.entries;
				}

				this.loaderStat = false;
				this.loadingMore = false;
			}
		},
		formatTime(seconds) {
			const hours = Math.floor(seconds / 3600);
			const minutes = Math.floor((seconds % 3600) / 60);
			const secs = seconds % 60;
			const pad = (num) => String(num).padStart(2, "0");

			if (seconds >= 3600) {
				return `${pad(hours)}:${pad(
					minutes
				)} <span class="game-grey-txt-3">hrs</span>`;
			} else if (seconds >= 60) {
				return `${pad(minutes)}:${pad(
					secs
				)} <span class="game-grey-txt-3">mins</span>`;
			} else {
				return `00:${pad(secs)} <span class="game-grey-txt-3">mins</span>`;
			}
		},

		async getMyRank() {
			const res = await getMyRank(this.selectedGame.value);
			if (res.status == 200) {
				this.myRank = res.data.data;
				if (!this.myRank.rank) {
					this.hideProfile = true;
				} else {
					this.hideProfile = false;
				}
			} else {
				this.hideProfile = true;
			}
		},
		async getLeaderBoardCollege(append = false) {
			console.log("college called");
			this.loaderStat = !append;
			let payload = {};

			if (this.$route.name === "Leaderboard") {
				payload = {
					page: this.currentPage - 1,
					count: this.pageCount,
				};
			}

			const res = await getCollegeLeaderBoard(this.selectedGame.value, payload);
			if (res.status == 200) {
				if (this.$route.name === "Leaderboard") {
					this.total = res.data.totalCount;
					this.pageEnd = res.data.pageEnd;
					this.pageCount = res.data.count;
				}

				if (this.currentPage != 1 && !this.isLaptop) {
					// Appending — keep original pageStart so rank numbers stay correct
					this.leaderboardEntries = [
						...this.leaderboardEntries,
						...res.data.leaderboard,
					];
				} else {
					if (this.$route.name === "Leaderboard") {
						this.pageStart = res.data.pageStart;
					}
					this.isMyRowVisible = false;
					this.leaderboardEntries = res.data.leaderboard;
				}
				this.loaderStat = false;
				this.loadingMore = false;
			}
		},
		onTabChange(activeTab) {
			console.log("Selected tab index →", activeTab);
			this.currentPage = 1;
			this.loaderStat = true;
			if (this.isAssessment) {
				this.isAssessmentPosition = false;
				this.getAssessmentLeaderBoardData();
				this.getAssessmentPosition();
			} else if (activeTab == 0) {
				this.getLeaderBoard();
				this.getMyRank();
			} else if (activeTab == 1) {
				this.getLeaderBoardCollege();
			}
		},
		onPageChange(newPage) {
			this.currentPage = newPage;
			if (this.isLaptop) {
				this.loaderStat = true;
			}
			if (this.isAssessment) {
				this.isAssessmentPosition = false;
				this.getAssessmentLeaderBoardData();
				this.getAssessmentPosition();
			} else if (this.activeTab == 0) {
				this.getLeaderBoard();
			} else {
				this.getLeaderBoardCollege();
			}
		},

		goToPage(pageNumberToGo) {
			this.currentPage = pageNumberToGo;
			this.pageNumberToGo = "";
			this.loaderStat = true;
			if (this.isAssessment) {
				this.isAssessmentPosition = false;
				this.getAssessmentLeaderBoardData();
				this.getAssessmentPosition();
			} else if (this.activeTab == 0) {
				this.getLeaderBoard();
			} else if (this.activeTab == 1) {
				this.getLeaderBoardCollege();
			}
		},
		checkDigit(event) {
			if (event.key.length === 1 && isNaN(Number(event.key))) {
				event.preventDefault();
			}
		},
		onScroll(e) {
			// Check if mobile view (adjust breakpoint as needed, e.g., 1028px matches your CSS)
			if (window.innerWidth > 1028) return;

			const { target } = e;
			if (
				Math.ceil(target.scrollTop) >=
					target.scrollHeight - target.offsetHeight - 10 && // Added buffer
				!this.loadingMore
			) {
				if (this.checkbetween(this.pageEnd, 0, this.total)) {
					this.loadingMore = true;
					this.currentPage++;
					if (this.isAssessment) {
						this.isAssessmentPosition = false;
						this.getAssessmentLeaderBoardData(true);
						this.getAssessmentPosition();
					} else if (this.activeTab == 0) {
						this.getLeaderBoard(true);
					} else {
						this.getLeaderBoardCollege(true);
					}
				}
			}
		},
		checkbetween(x, min, max) {
			return x > min && x < max;
		},
		isValidPage(page) {
			const totalPages = Math.ceil(this.total / this.pageCount);
			return /^\d*$/.test(page) && page > 0 && page <= totalPages;
		},
		updatePageCount(pageCount) {
			this.pageCount = pageCount;
			this.currentPage = 1;
			if (this.isAssessment) {
				this.isAssessmentPosition = false;
				this.getAssessmentLeaderBoardData(true);
				this.getAssessmentPosition();
			} else if (this.activeTab == 0) {
				this.getLeaderBoard(true);
			} else {
				this.getLeaderBoardCollege(true);
			}
		},
		setupIntersectionObserver() {
			if (this.observer) {
				this.observer.disconnect();
			}
			this.isMyRowVisible = false;

			this.observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						this.isMyRowVisible = entry.isIntersecting;
					});
				},
				{
					root: null,
					threshold: 0.1,
				}
			);

			this.$nextTick(() => {
				const target = this.$refs.myRankRow;
				if (target && target[0]) {
					this.observer.observe(target[0]);
				} else if (target instanceof Element) {
					this.observer.observe(target);
				}
			});
		},
	},
};
</script>
<style scoped>
.cand-dashboard-maincontainer .cand-header {
	display: none;
}
.cand-dashboard-maincontainer-lead .game-grid-container {
	display: grid;
	grid-template-columns: 2.5fr 1fr;
	gap: 10px;
	max-width: 1825px;
	padding: 0;
	margin-top: 10px;
	height: calc(100vh - 152px);
}
.cand-dash-games .game-grid-container {
	display: unset;
	grid-template-columns: 1fr;
	padding-bottom: 3px;
	height: unset;
}
.cand-dashboard-maincontainer-lead .leaderboard-left {
	background: #ffffff;
	box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	gap: 10px;
	padding: 15px;
	max-width: 100%;
	height: 100%;
	overflow: auto;
}
.cand-dash-games .game-right {
	background-color: var(--bg-white);
	padding: 0px;
	border: 1px solid #d9d9d9;
	box-shadow: 0px 4px 4px 0px #00000040;
	border-radius: 8px;
	max-width: 100%;
	text-align: left;
}
.cand-dash-games .game-lb-top-overflow {
	min-height: 65px;
	max-height: calc(100vh - 411px);
	overflow-y: auto;
}

.cand-dash-games .game-lb-top-overflow-2 {
	height: 350px;
	overflow-y: hidden;
}

.cand-dash-games .game-lb-top-overflow-3 {
	min-height: 65px;
	height: calc(100vh - 326px);
	overflow-y: auto;
}
.cand-dashboard-maincontainer-lead .lb-no-played-card {
	display: none;
}
.cand-dash-games .lb-no-played-card {
	background-color: #d7e0e7;
	display: flex;
	align-content: center;
	justify-content: space-between;
	padding: 10px;
}
.cand-dashboard-maincontainer-lead .game-lb-top-overflow {
	min-height: auto;
	max-height: calc(100vh - 346px);
	overflow-y: auto;
}
.cand-dashboard-maincontainer-lead .game-lb-top-overflow.candidates-view {
	height: calc(100vh - 355px);
	overflow-y: auto;
}
.cand-dashboard-maincontainer-lead .game-lb-top-overflow.colleges-view {
	min-height: calc(100vh - 264px);
	max-height: calc(100vh - 264px);
	overflow-y: auto;
}
.cand-dashboard-maincontainer-lead .game-lb-top-overflow.assessment-view {
	min-height: calc(100vh - 360px);
	max-height: calc(100vh - 360px);
	overflow-y: auto;
}
.cand-dashboard-maincontainer-lead .game-lb-top-overflow.sticky-hidden {
	height: calc(100vh - 265px) !important;
	max-height: calc(100vh - 265px) !important;
}
.cand-dashboard-maincontainer-lead .game-lb-top-overflow-3 {
	min-height: auto;
	max-height: calc(100vh - 225px);
	overflow-y: auto;
}
.cand-dashboard-maincontainer-lead .game-lb-top-overflow-4 {
	min-height: auto;
	max-height: calc(100vh - 246px);
	overflow-y: auto;
}
.cand-dashboard-maincontainer-lead .games-lb-heading {
	display: none !important;
}
.cand-dashboard-maincontainer-lead #laptopdropdown {
	display: none;
}
.cand-dash-games .laptop-lb-tabs {
	display: none;
}
.cand-dashboard-maincontainer-lead .cand-games-view-more {
	display: none !important;
}
.cand-dash-games .leaderboard-right-container {
	display: none;
}
.cand-dashboard-maincontainer-lead .lb-right-subcontainer {
	background: #ffffff;
	border: 1px solid rgba(140, 140, 140, 0.33);
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
}
.cand-dashboard-maincontainer-lead .leaderboard-right-container {
	height: 100%;
	overflow: auto;
}
.leader-name-width {
	max-width: 250px;
}
.cand-dashboard-maincontainer-lead .leader-name-width {
	width: 45vw;
	max-width: unset;
}
.cand-dash-games .leaderboard-skeleton {
	height: calc(100vh - 325px);
	overflow: auto;
}

.lb-play-btn {
	padding: 4px 22px !important;
}

@media (max-width: 1028px) {
	.cand-dashboard-maincontainer-lead {
		background: #e9ecef;
		padding: 0;
		top: 0;
		height: 100dvh;
		display: unset;
		overflow: hidden;
	}
	.lb-play-btn {
		padding: 4px 12px !important;
		width: 115px !important;
	}
	.lp-top-right-subheads {
		flex-direction: column;
	}
	.lp-top-right-subheads {
		align-items: baseline !important;
	}
	.lp-top-right-subheads span {
		margin-left: 0 !important;
	}
	.leader-name-width {
		width: 53vw;
	}
	.cand-dashboard-maincontainer-lead .leader-name-width {
		width: 45vw;
	}
	.cand-dashboard-maincontainer-lead .img-dimensions {
		height: 40px;
		width: 40px;
	}
	#mobile-gamecard {
		display: flex;
		align-items: center;
		width: 100%;
	}
	.mobile-gamecard-heading {
		display: flex;
		flex-direction: column;
		width: 75%;
	}
	.lb-right-subcontainer {
		display: none;
	}
	.lb-top-card {
		position: absolute;
		top: 0%;
		left: 0;
		border-radius: 0px;
		border: none;
	}
	.cand-dashboard-maincontainer-lead .mob-back-header {
		display: flex;
	}
	.cand-dash-games .mob-back-header {
		display: none;
	}
	.lead-card-padding {
		padding: 10px 15px;
	}
	.laptop-lb-tabs {
		display: none;
	}
	.cand-dash-games {
		width: 100%;
	}
	.cand-dash-games .game-grid-container {
		display: flex;
		height: unset;
		max-width: 100%;
		margin-top: 0;
		padding: 0;
		position: unset;
		flex-direction: column;
		padding-bottom: 4px;
	}
	.cand-dashboard-maincontainer-lead .game-grid-container {
		display: flex;
		height: calc(100dvh - (60px + env(safe-area-inset-top)));
		margin-top: 0;
		position: relative;
		top: unset;
		width: 100%;
		gap: 0;
		flex-direction: column;
		overflow: auto;
		background: #e9ecef;
	}
	.cand-dashboard-maincontainer-lead .leaderboard-left {
		background: none;
		box-shadow: unset;
		width: 100%;
		height: 100%;
		padding: 105px 0 0 0;
		overflow: hidden;
	}
	.cand-dashboard-maincontainer-lead .leaderboard-left.assessment {
		padding: 0;
		flex-shrink: 0;
		height: unset;
	}
	.cand-dashboard-maincontainer-lead .lb-right-subcontainer {
		display: none;
	}
	.cand-header {
		display: none;
	}

	.cand-dashboard-maincontainer-lead .game-right {
		margin-top: 0px !important;
		/* max-width: 100%; */
	}

	.cand-dash-games .game-right-overflow {
		height: 100%;
		overflow: unset;
	}
	.cand-dashboard-maincontainer-lead .game-right-overflow {
		height: calc(100dvh - (60px + env(safe-area-inset-top) + 165px));
	}
	.cand-dashboard-maincontainer-lead
		.leaderboard-left.assessment
		.game-right-overflow {
		/* height: calc(100dvh - (60px + env(safe-area-inset-top) + 115px)); */
		height: unset;
	}
	.cand-dash-games .game-right {
		/* padding-bottom: 40px; */
	}
	.cand-dash-games .leaderboard-skeleton {
		height: unset;
		overflow: unset;
	}

	.cand-dash-games .game-lb-top-overflow,
	.cand-dash-games .game-lb-top-overflow-3 {
		max-height: unset;
		min-height: unset;
		overflow-y: unset;
		height: unset;
	}
	.cand-dashboard-maincontainer-lead .game-lb-top-overflow-3 {
		height: 97% !important;
		max-height: unset !important;
	}
	.cand-dashboard-maincontainer-lead .game-lb-top-overflow {
		height: 75%;
		overflow-y: auto;
	}
	.cand-dashboard-maincontainer-lead .game-lb-top-overflow.candidates-view {
		height: 75%;
		overflow-y: auto;
		max-height: unset;
	}
	.cand-dashboard-maincontainer-lead .game-lb-top-overflow.sticky-hidden {
		height: 88% !important;
	}
	.cand-dashboard-maincontainer-lead .game-lb-top-overflow.colleges-view {
		height: 90%;
		overflow-y: auto;
		max-height: unset;
	}
	.cand-dashboard-maincontainer-lead .game-lb-top-overflow-4 {
		min-height: auto;
		max-height: calc(100vh - 246px) !important;
		overflow-y: auto;
	}
	.cand-dash-games .game-lb-top-overflow-2 {
		max-height: 350px;
		overflow-y: hidden;
	}
	.padding-left {
		padding: 0 0 0 20px;
	}
	.game-grey-txt-3 {
		font-size: var(--size-12);
		color: var(--cv-gray);
	}
	.game-black-txt {
		font-family: "Lato", sans-serif;
		font-size: var(--size-14);
		font-weight: var(--weight-B);
		color: var(--bg-proTheme);
	}
	.mobile-hr {
		background-color: #d9d9d9;
		margin: 0 0px;
		display: flex;
	}
	.cand-dashboard-maincontainer-lead .game-own-update {
		background-color: #cce1fa;
		margin-top: 15px;
	}
	.game-ur-position {
		background: unset;
		background-color: #d8e0ff;
		border-radius: 8px;
		font-size: var(--size-10);
		color: var(--bg-proTheme);
		position: absolute;
		left: 10px;
		padding: 8px 10px;
	}
	.game-grey-txt-4 {
		font-family: "Lato", sans-serif;
		font-size: var(--size-15);
		font-weight: var(--weight-M);
		color: var(--bg-proTheme);
	}
	.cand-dashboard-maincontainer-lead #mobiledropdown {
		display: flex;
		gap: 8px;
		padding: 5px 15px;
	}
	.cand-dash-games #mobiledropdown {
		display: flex;
		gap: 8px;
		padding: 5px 0;
	}
	#laptopdropdown {
		display: none;
	}
	.lead-empty-ht {
		height: 100%;
	}
	.laptop-hr {
		display: none;
	}
	.mobile-hide-pagination {
		display: none !important;
	}

	/* Slide-down transition for the Your Position card */
	.slide-down-enter-active,
	.slide-down-leave-active {
		transition: transform 0.35s ease, opacity 0.35s ease;
	}
	.slide-down-enter {
		transform: translateY(100%);
		opacity: 0;
	}
	.slide-down-leave-to {
		transform: translateY(100%);
		opacity: 0;
	}
}
</style>
<style>
@media (max-width: 1028px) {
	.cand-dashboard-maincontainer-lead .leaderboard-right-container {
		height: unset !important;
		flex-shrink: 0;
	}
	.leaderboard-tabs {
		height: 35px;
		width: 100%;
	}
	.leaderboard-tabs .nav-tabs {
		width: 100% !important;
	}
	.w80.mob {
		width: 73%;
	}
	.width54px.mob {
		width: 44px;
	}
}
.cand-dashboard-maincontainer-lead {
	position: relative;
	background: var(--bg-lightblueback);
	height: calc(100vh - 60px);
	top: 60px;
	/* padding-left: 80px; */
	overflow-x: hidden;
	/* padding-right: 15px; */
	padding: 15px 15px 15px 75px;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.lb-right-card-height {
	height: calc(100vh - 365px);
	overflow: auto;
}
.h-40px {
	height: 40px;
}
.lb-right-ads-card {
	background: #bbddd8;
	height: 173px;
	border: 1px solid rgba(140, 140, 140, 0.33);
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
}
.leaderboard-right h3 {
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-B);
	font-size: var(--size-16);
	color: #1f629b;
}
.leaderboard-right p {
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-LM);
	font-size: var(--size-12);
	color: #7a7a7a;
}
.lb-right-cardimg {
	bottom: 0;
	right: 0;
}
.lb-right-btn {
	position: absolute;
	bottom: 10px;
	left: 8px;
	background: #e8eff4;
	border-radius: 40px;
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-M);
	font-size: var(--size-11);
	color: #1f629b;
	width: 94%;
}
.lb-right-card {
	height: 173px;
	background: #ffffff;
	border: 1px solid rgba(140, 140, 140, 0.33);
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
}
.lb-top-card h3 {
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-M);
	font-size: var(--size-14);
	color: #000000;
}
.lp-top-right-subheads {
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-R);
	font-size: var(--size-13);
	color: #828282;
}
.lb-top-card {
	padding: 8px;
	/* height: 100px; */
	background: #d7e0e7;
	border-radius: 8px;
}
.leaderboard-right {
	height: calc(100vh - 265px);
}
.lb-total-user {
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-R);
	font-weight: var(--size-14);
	color: #828282;
}

.game-card {
	background: linear-gradient(180deg, rgba(32, 99, 155, 0.62) 0%, #000000 100%);
	height: 230px;
	border-radius: 8px;
	border: none;
	overflow: hidden;
	position: relative;
}

.game-dropdown {
	position: relative;
}

.game-drop-parent .btn-group {
	width: 100%;
}
.cand-dashboard-maincontainer .card-header {
	display: none;
}

.game-drop-parent .btn-secondary {
	background-color: var(--bg-white) !important;
	font-family: "Montserrat", sans-serif !important;
	font-size: var(--size-16) !important;
	font-weight: var(--weight-LM) !important;
	border-radius: 8px;
	height: 34px;
	color: #667085 !important;
	padding: 7px 15px;
	border: 1px solid #d9d9d9;
	border-color: #d9d9d9 !important;
	width: 100%;
	box-shadow: 0px 1px 2px 0px #1018280d;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.game-drop-parent .btn-secondary:not(:disabled):not(.disabled):active,
.game-drop-parent .btn-secondary:not(:disabled):not(.disabled).active,
.game-drop-parent .show > .btn-secondary.dropdown-toggle {
	color: #667085 !important;
	background-color: var(--bg-white) !important;
	border: 1px solid #d9d9d9 !important;
	font-family: "Montserrat", sans-serif !important;
	font-size: var(--size-16) !important;
	font-weight: var(--weight-LM) !important;
	height: 34px !important;
	padding: 5px 15px !important;
	width: 100% !important;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.game-drop-parent .dropdown-menu {
	padding: 0;
	box-shadow: 0px 8px 15px 0px #00000066;
	border: 1px solid transparent;
	background-color: #f9f9f9;
	border-radius: 4px;
	width: 100%;
}

.game-drop-parent .dropdown-item {
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
	color: var(--cv-lightGray);
	padding: 8px 15px;
	border-radius: 4px;
}

.game-drop-parent .dropdown-item.active,
.game-drop-parent .dropdown-item:active {
	background-color: #e8eff4;
}

.game-dropdown-overflow {
	min-height: auto;
	max-height: 200px;
	overflow: auto;
}

.game-dropdown-overflow::-webkit-scrollbar {
	scroll-behavior: smooth;
	width: 2px !important;
	height: 10px !important;
	background-color: #e8eff4 !important;
}

.padding-left {
	padding: 0 20px;
}

.game-grey-txt {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-M);
	color: #40404c;
}

.game-grey-txt-2 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
	color: #555555;
}

.game-grey-txt-3 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-R);
	color: #40404c;
}

.game-grey-txt-4 {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	color: #606060;
}

.game-grey-txt-5 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-12);
	font-weight: var(--weight-M);
	color: #555555;
}

.game-black-txt {
	font-family: "Lato", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-M);
	color: var(--cv-black);
}

.game-blue-txt {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	color: var(--bg-proTheme);
}

.game-blue-txt-2 {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-M);
	color: var(--bg-proTheme);
}

.width54px {
	width: 54px;
	flex-shrink: 0;
}

.mobile-hr {
	display: none;
}

.game-own-update {
	background-color: #f3f6ffd6;
	position: relative;
	margin-top: 25px;
}

.game-ur-position {
	background: linear-gradient(
		90deg,
		var(--bg-proTheme) 0%,
		rgba(32, 99, 155, 0.52) 100%
	);
	border-radius: 4px 4px 0px 0px;
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-12);
	font-weight: var(--weight-M);
	color: var(--bg-white);
	position: absolute;
	top: -22px;
	padding: 2px 10px;
}
.lead-card-padding {
	padding: 10px 15px;
}

#mobiledropdown {
	display: none;
}
.laptop-lb-tabs {
	display: flex;
}
.lb-right-subcontainer {
	display: block;
}
.img-box-shadow {
	box-shadow: 0px 0px 4px 0px #00000040;
	border-radius: 8px;
}
.lb-img-box-shadow {
	height: 60px;
	width: 60px;
	box-shadow: 0px 0px 4px 0px #00000040;
	border-radius: 8px;
}
/* .cand-img-dim {
	height: 100px;
	width: 100px;
	border-radius: 50%;
} */
.cand-dashboard-maincontainer-lead .img-dimensions {
	height: 50px;
	width: 50px;
	display: block;
	flex-shrink: 0;
}
.img-dimensions {
	display: none;
}
.w57 {
	width: 57%;
}
.lead-empty-txt {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	color: #000000;
}
.lead-empty-ht {
	height: calc(100vh - 260px);
}
.leaderboard-tabs .nav-tabs {
	background: rgba(32, 99, 155, 0.12);
	border-radius: 50px;
	padding: 0;
	border: none !important;
	width: 240px;
}

.leaderboard-tabs .nav-item {
	width: 50%;
	text-align: center;
}

.leaderboard-tabs .nav-tabs .nav-link {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 12px;
	color: #333333;
	border: none !important; /* remove default border */
	border-radius: 50px !important; /* rounded corners always */
	background: transparent !important; /* prevent white flash */
	transition: background-color 0.25s ease, color 0.25s ease; /* smooth switch */
	padding: 0.5rem 1rem;
	box-shadow: none !important;
}

.leaderboard-tabs .nav-tabs .nav-link.active,
.leaderboard-tabs .nav-item.show .nav-link {
	color: #ffffff !important;
	background-color: #20639b !important;
	border: none !important;
	border-radius: 50px !important;
	box-shadow: none !important;
}

.leaderboard-tabs .nav-tabs .nav-link:hover,
.leaderboard-tabs .nav-tabs .nav-link:focus {
	border-color: transparent !important;
	background: rgba(32, 99, 155, 0.1);
	outline: none !important;
	box-shadow: none !important;
}

.leaderboard-tabs:focus-visible {
	outline: unset;
}
.color-828282 {
	color: #828282;
}

.cand-dashboard-maincontainer-lead .game-lb-top-overflow-4.candidates-view {
	height: calc(100vh - 255px) !important;
	overflow-y: auto;
}
.my-rank-highlight {
	background-color: #f3f6ffd6 !important;
}
</style>
